<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" @close="close" class="w-[800px]">

    <strong class="block mb-8 pr-8 pb-8 uppercase font-bold text-2xl border-b border-neutral-200 tablet:px-6 desktop:px-10">
      <AtomsImagesIcon icon="truck" /> {{ $t('Product with limited shipping options') }}
    </strong>

    <div class="tablet:px-6 desktop:px-10">

      {{ $t('For legislative reasons, we can only ship the product to certain countries. Below you will find a list of countries to which the product can be shipped.') }}

      <div class="limited-shipping__list">
        <table class="limited-shipping__table">
          <thead>
            <tr v-show="countriesForDropDown.length > 2">
              <td colspan="2">
                <div class="flex items-center justify-center gap-4">
                  {{ $t('Země') }}:
                  <MoleculesFormsDropDown :options="countriesForDropDown" :placeholder="$t('Vyberte nebo vyhledejte zemi')" v-model="selectedCountry" label-field="name" value-field="id" class="max-w-[400px] !mx-0" />
                </div>
              </td>
            </tr>
            <tr class="limited-shipping__table__header">
              <td>{{ $t('Destination country') }}</td>
              <td>{{ $t('Possible delivery') }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in results">
              <td>{{ row.name }}</td>
              <td :class="{'text-error-600' : !row.enabled, 'text-success-500' : row.enabled}"><AtomsImagesIcon :icon="row.enabled ? 'checked' : 'cross'" size="xs" class="mr-1" /> {{ row.enabled ? $t('Can be sent') : $t('Cannot be sent') }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

  </AtomsGlobalDialog>
</template>
<script setup>

const i18n = useI18n();
const locale = useLocale().getLocale();

const dialog = computed(() => useDialog().get('limitedShipping'));

const close = () => useDialog().close();

const countries = computed(() => dialog.value?.data.countries.sort((a, b) => a.name.localeCompare(b.name)));

const countriesForDropDown = computed(() => [{ id: null, name: i18n.t('Všechny země') }, ...countries.value ?? []]);

const countryByIp = (await useApiFetch(`/api/countryByIP?languageId=${locale.languageId}&currencyId=${locale.currencyId}`))?.countryByIp.country?.id;

const selectedCountry = ref(countryByIp);

const results = computed(() => {

  // if country is selected, check if it really exists, otherwise show all countries
  const selectedCountryObject = countries.value?.filter(country => country.id === selectedCountry.value || selectedCountry.value == null || (selectedCountry.value !== null && !countries.value.some(someCountry => someCountry.id === selectedCountry.value)));

  return selectedCountryObject;
});

</script>
<style lang="postcss">
.limited-shipping {

  &__list {

    @apply my-8 leading-6 tracking-normal;
  }

  &__table {
    @apply w-full;

    tr {
      @apply bg-neutral-100 even:bg-neutral-50;
    }

    td {
      @apply p-3 text-left;
    }

    tbody {
      .limited-shipping__table__price {
        @apply !text-right;
      }
    }

    thead {
      .limited-shipping__table__price {
        @apply max-w-[80px] !text-center;
      }
    }

    &__header {
      @apply font-bold text-neutral-50 !bg-neutral-500;
    }

  }
}
</style>